/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Apikey_Failedclear2Inputs */

const id_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal menghapus kunci API`)
};

const ms_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal mengosongkan kunci API`)
};

const da_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke rydde API nøgle`)
};

const de_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel konnte nicht gelöscht werden`)
};

const en_us2_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to clear API key`)
};

const es_es2_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al borrar la clave de API`)
};

const es_mx2_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al borrar la API key`)
};

const fil_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigong i-clear ang API key`)
};

const fr_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'effacement de la clé API`)
};

const it_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile cancellare la chiave API`)
};

const hu_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikertelen API kulcs törlés`)
};

const nl_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutel wissen mislukt`)
};

const no_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke fjerne API-nøkkel`)
};

const pl_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wyczyścić klucza API`)
};

const pt_br2_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to clear API key`)
};

const pt_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao limpar chave de API`)
};

const ro_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ștergerea cheii API a eșuat`)
};

const fi_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avaimen tyhjennys epäonnistui`)
};

const sv_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misslyckades att rensa API-nyckel`)
};

const vi_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể xóa khóa API`)
};

const tr_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarı temizlenemedi`)
};

const cs_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepodařilo se vymazat API klíč`)
};

const bg_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешно изчистване на API ключ`)
};

const ru_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось очистить API-ключ`)
};

const uk_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося очистити API-ключ`)
};

const ar_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل مسح مفتاح API`)
};

const hi_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API कुंजी साफ़ करने में विफल`)
};

const th_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล้างคีย์ API ไม่สำเร็จ`)
};

const ja_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーのクリアに失敗しました`)
};

const zh_cn2_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to clear API key`)
};

const zh_hant1_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to clear API key`)
};

const ko_notifications_apikey_failedclear2 = /** @type {(inputs: Notifications_Apikey_Failedclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to clear API key`)
};

/**
* | output |
* | --- |
* | "Failed to clear API key" |
*
* @param {Notifications_Apikey_Failedclear2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_apikey_failedclear2 = /** @type {((inputs?: Notifications_Apikey_Failedclear2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Apikey_Failedclear2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_apikey_failedclear2(inputs)
	if (locale === "ms") return ms_notifications_apikey_failedclear2(inputs)
	if (locale === "da") return da_notifications_apikey_failedclear2(inputs)
	if (locale === "de") return de_notifications_apikey_failedclear2(inputs)
	if (locale === "en-US") return en_us2_notifications_apikey_failedclear2(inputs)
	if (locale === "es-ES") return es_es2_notifications_apikey_failedclear2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_apikey_failedclear2(inputs)
	if (locale === "fil") return fil_notifications_apikey_failedclear2(inputs)
	if (locale === "fr") return fr_notifications_apikey_failedclear2(inputs)
	if (locale === "it") return it_notifications_apikey_failedclear2(inputs)
	if (locale === "hu") return hu_notifications_apikey_failedclear2(inputs)
	if (locale === "nl") return nl_notifications_apikey_failedclear2(inputs)
	if (locale === "no") return no_notifications_apikey_failedclear2(inputs)
	if (locale === "pl") return pl_notifications_apikey_failedclear2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_apikey_failedclear2(inputs)
	if (locale === "pt") return pt_notifications_apikey_failedclear2(inputs)
	if (locale === "ro") return ro_notifications_apikey_failedclear2(inputs)
	if (locale === "fi") return fi_notifications_apikey_failedclear2(inputs)
	if (locale === "sv") return sv_notifications_apikey_failedclear2(inputs)
	if (locale === "vi") return vi_notifications_apikey_failedclear2(inputs)
	if (locale === "tr") return tr_notifications_apikey_failedclear2(inputs)
	if (locale === "cs") return cs_notifications_apikey_failedclear2(inputs)
	if (locale === "bg") return bg_notifications_apikey_failedclear2(inputs)
	if (locale === "ru") return ru_notifications_apikey_failedclear2(inputs)
	if (locale === "uk") return uk_notifications_apikey_failedclear2(inputs)
	if (locale === "ar") return ar_notifications_apikey_failedclear2(inputs)
	if (locale === "hi") return hi_notifications_apikey_failedclear2(inputs)
	if (locale === "th") return th_notifications_apikey_failedclear2(inputs)
	if (locale === "ja") return ja_notifications_apikey_failedclear2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_apikey_failedclear2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_apikey_failedclear2(inputs)
	return ko_notifications_apikey_failedclear2(inputs)
});
export { notifications_apikey_failedclear2 as "notifications.apiKey.failedClear" }